<template>
  <!-- 白板頁 -->
  <div class="whiteboard-container">
    <div class="layout-container">
      <whiteboard-canvas class="whiteboard-canvas" ref="wbc"/>
      <whiteboard-boards-panel ref="boardsPanel" class="theme-color" @addEmptyBoard="addBoard" @addImageBoard="toggleFileUpload"/>
      <whiteboard-top-toolbar class="top-toolbar theme-color" @undo="undo" @redo="redo" @save="saveWhiteboardAsImage" />
      <whiteboard-left-toolbar class="left-toolbar theme-color" @clear="clearObjects" @rotate="rotateBackgroundImage" />
    </div>

    <app-file-upload
      ref="fileUpload"
      accept="image/*"
      :acceptExts="['jpg', 'jpeg', 'bmp', 'png']"
      :thumbQuality="0.8"
      @submit="addBoardsByFiles"/>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import WhiteboardCanvas from './WhiteboardCanvas';
import WhiteboardTopToolbar from './WhiteboardTopToolbar';
import WhiteboardLeftToolbar from './WhiteboardLeftToolbar';
import WhiteboardBoardsPanel from './WhiteboardBoardsPanel';

export default {
  components: {
    'whiteboard-canvas': WhiteboardCanvas,
    'whiteboard-top-toolbar': WhiteboardTopToolbar,
    'whiteboard-left-toolbar': WhiteboardLeftToolbar,
    'whiteboard-boards-panel': WhiteboardBoardsPanel
  },

  data() {
    return {
      imgs: []
    };
  },

  methods: {
    ...mapActions('whiteboard', {
      addBoard: 'addBoard',
      addBoardsByFiles: 'addBoardsByFiles'
    }),

    undo() {
      this.$refs.wbc.undo();
    },

    redo() {
      this.$refs.wbc.redo();
    },

    clearObjects() {
      this.$refs.wbc.clearObjects();
    },

    rotateBackgroundImage() {
      this.$refs.wbc.rotateBackgroundImage();
    },

    toggleFileUpload() {
      this.$refs.fileUpload.toggle();
    },

    saveWhiteboardAsImage(filename) {
      this.$refs.wbc.saveAsImage(filename);
    }
  }
};
</script>

<style lang="stylus" scoped>

$theme-color = $def-bg-color;

.theme-color {
  background-color: $theme-color;
}

.whiteboard-container {
  position: relative;
  display: flex;
  align-items: stretch;
  overflow: hidden;
}


.layout-container {
  // background-color: $def-bg-color;
  background-color: white;
  display: grid;
  width: 100%;
  grid-template-columns: 4.6rem 1fr;
  grid-template-rows: 48px auto;
  grid-template-areas: "left-toolbar top-toolbar" "left-toolbar whiteboard-canvas";
}

.top-toolbar {
  grid-area: top-toolbar;
}

.left-toolbar {
  grid-area: left-toolbar;
}

.whiteboard-canvas {
  grid-area: whiteboard-canvas;
}

</style>
